'use client';

import type {
  DeliverySize,
  LineItemFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import { Suspense } from 'react';
import { Card, CardContent } from '@packages/shared/src/ui/Card/Card';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';
import { AddedProduct } from '@packages/modules/src/AddToBasketLayer/AddedProduct/AddedProduct.client';
import { AddedProductLoadingFallback } from '@packages/modules/src/AddToBasketLayer/AddedProduct/AddedProductLoadingFallback/AddedProductLoadingFallback.client';
import type { AddToBasketRecommendationsData } from '../AddToBasketRecommendations';
import { AddToBasketRecommendations } from '../AddToBasketRecommendations';
import { AddToBasketLayerErrorFallback } from './AddToBasketLayerErrorFallback/AddToBasketLayerErrorFallback.client';
import { TaxHint } from '../TaxHint/TaxHint.client';

export type AddToBasketLayerData = AddToBasketRecommendationsData & {
  deliverySize: DeliverySize;
};

export type AddToBasketLayerProps = {
  lineItem: LineItemFragmentFragment;
  data: AddToBasketLayerData;
};

export const AddToBasketLayer = ({ lineItem, data }: AddToBasketLayerProps) => (
  <div className="bg-color-grey-light flex grow flex-col gap-2 p-1.5 xl:p-3">
    <Card>
      <CardContent className="pb-2">
        <ErrorBoundary fallback={(reset) => <AddToBasketLayerErrorFallback reset={reset} />}>
          <Suspense fallback={<AddedProductLoadingFallback />}>
            <AddedProduct
              lineItem={lineItem}
              taxHintSlot={<TaxHint deliverySize={data.deliverySize} />}
            />
          </Suspense>
        </ErrorBoundary>
      </CardContent>
    </Card>

    <AddToBasketRecommendations data={data} />
  </div>
);
